import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import React from "react";
import { css } from "styled-components";

export interface FooterSeperatorStyles {
    seperatorStyles?: InjectableCss;
}

export const footerSeperatorStyles: FooterSeperatorStyles = {
    seperatorStyles: {
        css: css`
            border-bottom: 1px solid ${COLORS.border.darkShade}; 
            margin: 40px 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    margin: 32px 0;
                    `,
                    css`
                    margin: 32px 0;
                    `,
                    null,     
                ]
            )};
        }
        `,
    },
};

type Props = WidgetProps;

const FooterSeperator: React.FC<Props> = () => {
    const styles = footerSeperatorStyles;

    return (
        <StyledWrapper {...styles.seperatorStyles}></StyledWrapper>
    );
};

const footerSeperator: WidgetModule = {
    component: FooterSeperator,
    definition: {
        group: "Footer",
        fieldDefinitions: [],
    },
};

export default footerSeperator;
